export default __webpack_public_path__ + "static/media/circle-double.71f5d80e.svg";